import checkoutStepBase from '../checkoutStepBase'
import api from '../../api/checkout'
import { mapGetters } from 'vuex'

export default {
    mixins: [checkoutStepBase],

    data() {
        return {
            paymentMode: this.checkoutData.userData.payment_mode,
            errors: null
        }
    },

    updated() {
        if ( !this.paymentMode ) {
            this.setInitialPaymentMode()
        }
    },

    computed: {
        ...mapGetters('cart', [
            'hasUnshippableItems',
        ]),

        defaultPaymentModeId() {
            let _shippingMode = this.checkoutData.userData['shipping_mode']
            let _paymentModes = this.checkoutData.shippingModes.find(shippingMode => shippingMode.id === _shippingMode).paymentModes
            const defaultMode = _paymentModes.find(paymentMode => paymentMode.isDefault)

            return defaultMode ? defaultMode.id : null
        },

        paymentModes() {
            let _shippingMode = this.checkoutData.userData['shipping_mode']
            if ( !_shippingMode ) { return [] }
            let _paymentModes = this.checkoutData.shippingModes.find(shippingMode => shippingMode.id === _shippingMode).paymentModes

            if (! this.hasUnshippableItems) {
                return _paymentModes
            }

            return _paymentModes.filter(mode => mode.isOnline)
        }
    },

    methods: {
        async next() {
            try {
                await api.setPaymentMode(this.paymentMode)
                this.errors = null
                this.$bus.$emit('payment-mode-saved', this.paymentMode)
                this.$bus.$emit('checkout-step-next')
            } catch (error) {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors
                }

                this.$bus.$emit('checkout-error', error)
            }
        },

        setInitialPaymentMode() {
            const _paymentMode = this.checkoutData.userData.payment_mode

            const paymentModeExist = this.paymentModes.find(paymentMode => paymentMode.id === _paymentMode)
            if ( paymentModeExist && paymentModeExist.id ) {
                this.paymentMode = paymentModeExist.id
            } else {
                this.paymentMode = this.defaultPaymentModeId
            }
        }
    }
}
